import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import SaleBlockData from '../../../Models/Content/SaleBlockData';
import SalesHeader from '../../Shared/SalesHeader/SalesHeader';
import Sale from './sale';

export default class SaleBlock extends EpiComponent<SaleBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['sale-block'];
    if (this.props.data.padding?.value) cssClasses.push(this.props.data.padding?.value);
    if (this.props.data.margin?.value) cssClasses.push(this.props.data.margin?.value);

    return (
      <div className={cssClasses.join(' ')}>
        <div className='sale-page-wrapper'>
          <SalesHeader />
          <Sale iContent={this.props.data} context={this.getContext()} />
        </div>
      </div>
    );
  }
}


